<template>
  <div>
    <b-form-select
      @change="showConfirmation(value, $event)"
      :disabled="session.role != 'ce' && session.role != 'superadmin'"
      :value="value"
      class="my-0"
      :class="
        value === 'new'
          ? 'text-warning'
          : '' || value === 'onprogress'
          ? 'text-info'
          : '' || value === 'approved'
          ? 'text-primary'
          : '' || value === 'rejected'
          ? 'text-danger'
          : ''
      "
      id="input-1"
    >
      <option value="new" class="text-warning">Baru</option>
      <option value="onprogress" class="text-info">Diproses</option>
      <option value="approved" class="text-primary">Diterima</option>
      <option value="rejected" class="text-danger">Ditolak</option>
    </b-form-select>
  </div>
</template>

<script>
export default {
  props: ["value", "editClaim"],
  data: function () {
    return {
      unconfirmedValue: "",
      session: this.$session.get("jwt"),
    };
  },
  methods: {
    refresh() {
      this.$store.dispatch(
        "PaxelBigCustomerModule/getPaxelBigCustomer",
        this.$route.params.id
      );
    },
    showConfirmation(newValue, e) {
      this.unconfirmedValue = e;
      const oldValue = this.value;
      this.$swal({
        title: "Ubah Status Customer??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();
          formData.append("status", e);
          this.$store
            .dispatch("PaxelBigCustomerModule/updateStatusPaxelBigCustomer", {
              id: this.$route.params.id,
              formData,
            })
            .then((response) => {
              this.loading = false;
              this.refresh();
              this.$swal({
                title: "Change!",
                text: "Your status has been change.",
                type: "success",
                showConfirmButton: false,
                timer: 1000,
              });
              this.value = e;
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        } else {
          this.refresh();
          this.value = undefined;
        }
      });
    },
  },
};
</script>

<style>
</style>